type IPropertyOption = {
  display_name_cn: string
  display_name_en: string
  value: string
  options: IPropertyOptionItem[]
}

type IPropertyOptionItem = {
  display_name_cn: string
  display_name_en: string
  value: string
  disabled?: boolean
}

export const renderPropertyOptions: IPropertyOption[] = [
  {
    display_name_cn: '药物属性',
    display_name_en: 'Drug Properties',
    value: 'drugProperties',
    options: [
      {
        display_name_cn: '药物',
        display_name_en: 'Drug',
        value: 'drug',
      },
      {
        display_name_cn: '药物类型',
        display_name_en: 'Drug Type',
        value: 'drugType',
      },
      {
        display_name_cn: '靶点',
        display_name_en: 'Target',
        value: 'target',
      },
      {
        display_name_cn: '适应症',
        display_name_en: 'Indication',
        value: 'indication',
      },
      {
        display_name_cn: '机构',
        display_name_en: 'Organization',
        value: 'organization',
      },
      {
        display_name_cn: '机构属性',
        display_name_en: 'Organization Attributes',
        value: 'organizationProperty',
      },
      {
        display_name_cn: '最高阶段',
        display_name_en: 'Highest Phase',
        value: 'highestPhase',
      },
      {
        display_name_cn: '作用机制',
        display_name_en: 'MOA',
        value: 'moa',
      },
      {
        display_name_cn: '化学修饰',
        display_name_en: 'Chemical Modification',
        value: 'chemicalModification',
      },
      {
        display_name_cn: '里程碑',
        display_name_en: 'Milestone',
        value: 'milestone',
      },
      {
        display_name_cn: '存在交易',
        display_name_en: 'Deal',
        value: 'deal',
      },
      {
        display_name_cn: 'ATC',
        display_name_en: 'ATC',
        value: 'atc',
      },
      {
        display_name_cn: '关键词',
        display_name_en: 'Keyword',
        value: 'keyword',
      },
    ],
  },
  {
    display_name_cn: '研发状态',
    display_name_en: 'R&D Status',
    value: 'rdStatus',
    options: [
      {
        display_name_cn: '当前研发状态',
        display_name_en: 'Current R&D Status',
        value: 'currentRdStatus',
      },
    ],
  },
]
